<!-- 盲盒开奖记录页面 -->
<template>
  <div class="blind-box-award-page" v-if="timeFilterList.length">
    <div class="title">{{$t('blindBoxAward.title')}}</div>
    <div class="award-filter-bar">
      <div class="award-bar-txt">{{$t('blindBoxAward.stars')}}</div>
      <div class="award-time-filter" @click="toggleTimeList">
        <i class="calendar-icon"></i>
        <span class="time-txt">{{selectedTime?.date}} {{timezone}}</span>
        <i class="arrow-icon" :class="{rotate:timeListShow}"></i>
      </div>

      <transition name="fade">
        <div class="time-filter-list" v-show="timeListShow">
          <div 
            v-for="item in timeFilterList" 
            :key="item.date" 
            class="time-filter-item" 
            :class="{selected: item.selected}"
            @click="selectTime(item)"
          >
            {{item.date}}
          </div>
        </div>      
      </transition>
    </div>

    <div class="award-list" v-if="awardRecords.length">
      <div class="award-item" 
        v-for="(item, index) in awardRecords" 
        :key="index"
      >
        <div class="award-icon" :class="{error:item.award_icon_error}">
          <img :src="item.treasure_icon" alt="" @error="item.award_icon_error=true">
        </div>
        <div class="award-detail">
          <div class="award-title">
            {{$t('blindBoxAward.send')}} {{item.source_treasure_name}}({{item.stars_cost}}) {{$t('blindBoxAward.andWon')}}
            <span class="award-name">{{item.treasure_name}}({{item.stars}})</span>
          </div>
          <div class="award-others">
            <div class="award-anchor">{{$t('blindBoxAward.to')}} {{item.to_mid_name}}</div>
            <div class="award-time">{{item.send_time}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="award-empty" v-else>{{$t('blindBoxAward.noReward')}}</div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, onMounted, onServerPrefetch } from 'vue';
import giftervice from '@/service/gift';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import type {IBlindBoxRecordItem} from '@/service/gift/types';
import { throttle } from '@/utils';

interface ITimeFilterItem {
  startTimestamp:number;
  endTimeStamp:number;
  date:string;
  selected:boolean;
}

const {t: $t} = useI18n();
const route = useRoute();
const timezone = ref('');
const getTimezone = () => {
  const d: Date = new Date();
  const offset: number = d.getTimezoneOffset();
  const sign: string = (offset < 0) ? '+' : '-';
  const hour: number = parseInt(Math.abs((offset / 60)).toFixed(0));
  return `GMT${sign}${hour}`;
};


const getTimeFilterList = ():ITimeFilterItem[] => {
  const DAY = 1000 * 60 *60 * 24;
 
  const getDate = (d:Date) => {
    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const date = d.getDate();
    return `${year}-${month}-${date}`;
  };

  const genFilterItem = (d:Date):ITimeFilterItem =>{
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);
    const date = getDate(d);
    const startTimestamp = d.getTime();
    const endTimeStamp = startTimestamp  + DAY - 1000;
    return {
      startTimestamp: startTimestamp,
      endTimeStamp: endTimeStamp,
      date,
      selected:false,
    };
  };

  // todo: 确认活动起始日期
  const startFilterItem = genFilterItem(new Date(2022,11,4));
  const endFilterItem = genFilterItem(new Date());
  endFilterItem.selected = true;
  let current = endFilterItem;
  const filterList = [];
  while(current.startTimestamp > startFilterItem.startTimestamp){
    filterList.push(current);
    const prevDate = new Date(current.startTimestamp - DAY);
    current = genFilterItem(prevDate);
  }
  filterList.push(startFilterItem);

  return filterList;
};

const timeFilterList = ref<ITimeFilterItem[]>([]);
const selectedTime = computed(() => {
  return timeFilterList.value.find(item => item.selected);
});

const source_treasure_id = route.query?.source_treasure_id;
const awardRecords = ref<IBlindBoxRecordItem[]>([]);
const pn = ref(1);
const ps = ref(50);
const total = ref(0);


onMounted(async() => {
  timezone.value = getTimezone();
  timeFilterList.value = getTimeFilterList();
  const recordList = await getRecordList();
  awardRecords.value = recordList;
  
  document.onscroll = throttle(() => {
    // scrollTop + clientHeight === scrollHeight
    const {scrollHeight, scrollTop, clientHeight} = document.scrollingElement;
    const dist = 100;
    if(scrollHeight - (scrollTop + clientHeight) <= dist){
      loadMore();
    }
  });
});

const getRecordList = async () =>{
  const stime = selectedTime.value!.startTimestamp / 1000;
  const etime = selectedTime.value!.endTimeStamp / 1000;
  // const stime = 1670083200;
  // const etime = 1670601600; 
  const {data} = await giftervice.getBlindBoxRecord({
    stime, 
    etime, 
    pn:pn.value, 
    ps:ps.value,
    source_treasure_id
  });
  pn.value = data.pn;
  ps.value = data.ps;
  total.value = data.total;
  return data.list;
};

const timeListShow = ref(false);
const toggleTimeList = () => {
  timeListShow.value=!timeListShow.value;
};

const selectTime = async(item:ITimeFilterItem) => {
  if(item.selected){
    return;
  }
  timeFilterList.value = timeFilterList.value.map(it => {
    it.selected = it.startTimestamp === item.startTimestamp;
    return it;
  });
  pn.value = 1;
  const recordList = await getRecordList();
  awardRecords.value = recordList;
  timeListShow.value = false;
};

const loadMore = async() => {
  if(total.value <= ps.value * pn.value){
    console.log('loadMore, no more content');
    return;
  }
  pn.value = pn.value + 1;
  const recordList = await getRecordList();
  awardRecords.value = awardRecords.value.concat(recordList);
};
</script>


<style lang="less">
// 稿子 375px, 1vw = 375px
// html.font-size = 26.6666vw,  html.font-size = 375px * 0.26666 = 100px
// 1rem = 100px
html {
  font-size: 26.6666vw !important;

  body {
    font-size: 0.14rem;
  }
}
</style>

<style lang="less" scoped>
.blind-box-award-page {
  max-width: 750px;
  background-image: linear-gradient(180deg, #7e0e0e 0%, #3f0505 17%);
  min-height: 100vh;

  .title {
    font-size: 0.16rem;
    color: rgba(255, 255, 255, 0.9);
    letter-spacing: 0;
    line-height: 0.18rem;
    font-weight: 700;
    padding: 0.24rem 0;
    text-align: center;
  }

  .award-filter-bar {
    position: relative;
    width: 3.59rem;
    height: 0.32rem;
    margin: 0 0.08rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.12rem 0 0.16rem;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 0.04rem;
    cursor: pointer;

    .award-bar-txt {
      font-size: 0.12rem;
      color: rgba(255, 255, 255, 0.9);
      letter-spacing: 0;
      line-height: 0.18rem;
      font-weight: 700;
    }

    .award-time-filter {
      display: inline-flex;
      align-items: center;

      .calendar-icon {
        width: 0.18rem;
        height: 0.18rem;
        background: url('@/assets/blind-box-award/calendar.png') no-repeat center center;
        background-size: 100%;
      }

      .time-txt {
        font-size: 0.12rem;
        color: #fff;
        letter-spacing: 0;
        font-weight: 400;
        padding: 0 0.04rem;
      }

      .arrow-icon {
        width: 0.18rem;
        height: 0.18rem;
        background: url('@/assets/blind-box-award/arrow.png') no-repeat center center;
        background-size: 100%;
        transform: rotateZ(180deg);
        transition: transform 0.2s;

        &.rotate {
          transform: rotateZ(0);
        }
      }
    }

    .time-filter-list {
      position: absolute;
      height: 1.7rem;
      width: 1.1rem;
      right: 0;
      top: 0.32rem;
      background: #333;
      border-radius: 0.04rem;
      padding: 0.04rem;
      overflow: auto;

      .time-filter-item {
        width: 1.02rem;
        height: 0.33rem;
        line-height: 0.33rem;
        text-align: center;
        font-size: 0.12rem;
        color: rgba(255, 255, 255, 0.9);
        letter-spacing: 0;
        font-weight: 400;

        &.selected {
          background: #666;
          border-radius: 0.02rem;
        }
      }
    }
  }

  .award-list {
    padding: 0.04rem 0.11rem;

    .award-item {
      width: 100%;
      height: 0.64rem;
      background: rgba(255, 255, 255, 0.05);
      border-radius: 0.02rem;
      display: flex;
      align-items: center;
      padding: 0 0.08rem;

      &:not(:first-of-type) {
        margin-top: 0.04rem;
      }

      .award-icon {
        width: 0.52rem;
        height: 0.52rem;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 0.04rem;
        margin-right: 0.08rem;
        flex-shrink: 0;

        &.error {
          background: url('@/assets/blind-box-award/gift-icon-bg.png') no-repeat center center rgba(255, 255, 255, 0.1);
          background-size: 100%;
        }
      }

      .award-detail {
        flex-grow: 1;

        .award-title {
          font-size: 0.12rem;
          color: rgba(255, 255, 255, 0.9);
          letter-spacing: 0;
          height: 0.36rem;
          line-height: 0.18rem;
          font-weight: 400;
          display: -webkit-box !important;
          overflow: hidden;
          text-overflow: ellipsis;
          // word-break: break-all;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;

          .award-name {
            color: #ffab00;
          }
        }

        .award-others {
          margin-top: 0.02rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 0.12rem;
          color: rgba(255, 255, 255, 0.8);
          letter-spacing: 0;
          line-height: 0.14rem;
          font-weight: 400;

          .award-anchor {
            width: 1.6rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .award-empty {
    height: 1.4rem;
    width: 100%;
    margin-top: 0.6rem;
    padding-top: 1.1rem;
    background: url('@/assets/blind-box-award/empty.png') no-repeat top center;
    background-size: 1.16rem;
    font-size: 0.14rem;
    color: rgba(255, 255, 255, 0.9);
    letter-spacing: 0;
    line-height: 0.18rem;
    font-weight: 400;
    text-align: center;
  }
}

body {
  max-width: 750px;
  background-image: linear-gradient(180deg, #7e0e0e 0%, #3f0505 17%);
  min-height: 100vh;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>